$(document).ready(function(){
	$('.js-open-modal').click(function(e){
		e.preventDefault();
		$('.js-modal').addClass('active');

		$('body').addClass('scroll-locked');
		$('html').addClass('scroll-locked');
	});

	$('.js-open-form-1-modal').click(function(e){
		e.preventDefault();
		$('.js-form-1-modal').addClass('active');
		$('.js-modal').addClass('active');

		$('body').addClass('scroll-locked');
		$('html').addClass('scroll-locked');
	});

	$('.js-open-form-2-modal').click(function(e){
		e.preventDefault();
		$('.js-form-2-modal').addClass('active');
		$('.js-modal').addClass('active');

		$('body').addClass('scroll-locked');
		$('html').addClass('scroll-locked');
	});

	$('.js-close-modal').click(function(e){
		e.preventDefault();
		$('.js-modal').removeClass('active');
		$('.js-form-1-modal').removeClass('active');
		$('.js-form-2-modal').removeClass('active');

		$('body').removeClass('scroll-locked');
		$('html').removeClass('scroll-locked');
	});

	$('.js-toggle-accordion').click(function(){

		if ($(this).parent().hasClass('active')) {
			$(this).next().slideUp();
			$(this).parent().removeClass('active');
		} else {
			$(this).next().slideDown();
			$(this).parent().addClass('active');
		}

	});

	// if cookie does not exist, remove toggle class
	if (!!Cookies.get('announcement-pop-up')) {
	 // have cookie
	} else {
	 // no cookie
	 $('.announcement-pop-up__background, .announcement-pop-up').removeClass('announcement-toggle');
	}

    $('.announcement-x-image').on('click', function() {
      $('.announcement-pop-up__background, .announcement-pop-up').addClass('announcement-toggle');
      var inOneHour = 0.0417;

      Cookies.set('announcement-pop-up', 1, { expires: inOneHour });
    });

});

$(window).bind("load", function(){
	if ($('.js-engraving').length) {

        let noEngraving = false; 


        $('.single-option-selector').each(function(){
            if ($(this).val().toLowerCase() == 'no engraving') {
                noEngraving = true; 
                $('.js-engraving').addClass('hidden');
            }
        }); 

        if (noEngraving !== true) {

            $('.product-submit').addClass('disabled').attr('disabled', 'disabled');

            $('#engraving').keyup(function(){
                if (!$('#engraving').val().length == 0) {
                    $('.product-submit').removeClass('disabled').attr('disabled', false);
                } else {
                    console.log('no val');
                    $('.product-submit').addClass('disabled').attr('disabled', 'disabled');
                }
            });

        }

	}

	if ($('.js-mtm-size').length) {

		$('.product-submit').addClass('disabled').attr('disabled', 'disabled');

		$('#mtm-size').change(function(){
		    if ($('#mtm-size').val() != 'Select size') {

				$('#mtm-size').siblings('[data-selected-option]').text($('#mtm-size').val());

		    	$('.product-submit').removeClass('disabled').attr('disabled', false);
		    } else {
		    	console.log('no val');

				$('#mtm-size').siblings('[data-selected-option]').text($('#mtm-size').val());

		    	$('.product-submit').addClass('disabled').attr('disabled', 'disabled');
		    }
		});

	}

	$("select option[value='Select size']").each(function(){
		$(this).siblings().prop("selected", false);
		$(this).prop("disabled", false).prop("selected", true);
		$(this).parent().prev().text('Select size');
	});

	var $customContactButton = $('<div class="custom-button custom-button--size"><span>For Custom Stone Size requests, please fill out this form:</span><a href="https://hnuj1hqnnfp.typeform.com/to/ITFWszLJ" target="_blank" class="action-button submit">Contact Us</a></div>');
	var $heirloomCcontactButton = $('<div class="custom-button custom-button--heirloom"><span>For Heirloom Stone requests, please fill out this form:</span><a href="https://hnuj1hqnnfp.typeform.com/to/uMKqTUID" target="_blank" class="action-button submit">Contact Us</a></div>');

	$("select option[value='Custom Stone Size']").each(function(){

		 if($(this).is(':selected')) {
			$('.product-submit').addClass('disabled').attr('disabled', 'disabled');
			$customContactButton.insertBefore($('.product-submit:not(.bold_hidden)'));

			$(this).parent().parent().siblings().children('select').each(function(){
				$(this).addClass('disabled').attr('disabled', 'disabled');
			});

			$('#mtm-size').addClass('disabled').attr('disabled', 'disabled');
		 } else {
			$('.custom-button--size').remove();
		 }


		 $(this).parent().on('change', function() {
			var select = $(this).children("option:selected").val();

			if(select == 'Custom Stone Size') {
				$('.product-submit').addClass('disabled').attr('disabled', 'disabled');
				$customContactButton.insertBefore($('.product-submit:not(.bold_hidden)'));

				$(this).parent().siblings().children('select').each(function(){
					$(this).addClass('disabled').attr('disabled', 'disabled');
				});

				$('#mtm-size').addClass('disabled').attr('disabled', 'disabled');

			} else if(select == 'I’ll provide an heirloom stone') {
				$('.custom-button--size').remove();

				$(this).parent().siblings().children('select').each(function(){
					$(this).addClass('disabled').attr('disabled', 'disabled');
				});

				$('#mtm-size').addClass('disabled').attr('disabled', 'disabled');
			} else {
				$('.custom-button--size').remove();

				$(this).parent().siblings().children('select').each(function(){
					$(this).removeClass('disabled').attr('disabled', false);
				});
				
				$('#mtm-size').removeClass('disabled').attr('disabled', false);
			 }

			 if ($('.js-mtm-size').length) {

				if ($('#mtm-size').val() == 'Select size') {
					$('.product-submit').addClass('disabled').attr('disabled', 'disabled');
				}
		
			}
		});

	});


	$("select option[value='I’ll provide an heirloom stone']").each(function(){

		 if($(this).is(':selected')) {
			$('.product-submit').addClass('disabled').attr('disabled', 'disabled');
			$heirloomCcontactButton.insertBefore($('.product-submit:not(.bold_hidden)'));

			console.log('heirloom selected');

			$(this).parent().parent().siblings().children('select').each(function(){
				$(this).addClass('disabled').attr('disabled', 'disabled');
			});

			$('#mtm-size').addClass('disabled').attr('disabled', 'disabled');
		 } else {
			$('.custom-button--heirloom').remove();
		 }

		 $(this).parent().on('change', function() {
			var select = $(this).children("option:selected").val();

			if(select == 'I’ll provide an heirloom stone') {
				$('.product-submit').addClass('disabled').attr('disabled', 'disabled');
				$heirloomCcontactButton.insertBefore($('.product-submit:not(.bold_hidden)'));

				$(this).parent().siblings().children('select').each(function(){
					$(this).addClass('disabled').attr('disabled', 'disabled');
				});
			} else if(select == 'Custom Stone Size') {
				$('.custom-button--heirloom').remove();

				$(this).parent().siblings().children('select').each(function(){
					$(this).addClass('disabled').attr('disabled', 'disabled');
				});

				$('#mtm-size').addClass('disabled').attr('disabled', 'disabled');
			} else {
				$('.custom-button--heirloom').remove();

				$(this).parent().siblings().children('select').each(function(){
					$(this).removeClass('disabled').attr('disabled', false);
				});
				
				$('#mtm-size').removeClass('disabled').attr('disabled', false);
			 }

			 if ($('.js-mtm-size').length) {

				if ($('#mtm-size').val() == 'Select size') {
					$('.product-submit').addClass('disabled').attr('disabled', 'disabled');
				}
		
			}
		});

	});

	var filterTrigger = '<div class="filter-trigger">Show Filters<div>',
		collectionFilters = $('.collection-filters-container').children();
	
	$(collectionFilters).wrapAll("<div class='collection-filters' />");
	$(filterTrigger).prependTo('.collection-filters-container');

	if ($(window).width() <= 940) {
		collectionFilters.slideUp();
	}

	$(filterTrigger).click(function(){
		console.log('test');
	});

	$(document).on('click', '.filter-trigger' , function() {
	     //code here ....
	     $('.filter-trigger').toggleClass('active');
	     $('.filter-trigger').text($(this).text() == 'Show Filters' ? 'Hide Filters' : 'Show Filters');
	     collectionFilters.slideToggle();
	});

	$(window).resize(function(){
		if ($(window).width() >= 940) {
			collectionFilters.slideDown();
		}
	})

});